'use strict';

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _assets = require('../../utils/assets');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var safeSum = function safeSum(object, fields) {
  var sum = void 0;

  _lodash2.default.forEach(fields, function (f) {
    var v = _lodash2.default.get(object, f, 0);
    sum += v;
  });

  return sum || '';
};

var replaceHash = function replaceHash(text) {
  return _lodash2.default.replace(text, /\n/g, '%23');
};
var replaceNumberSign = function replaceNumberSign(text) {
  return _lodash2.default.replace(text, /#/g, '');
};

var safeDescription = function safeDescription(text) {
  var safe = _lodash2.default.replace(text, /\n/g, ' ');
  safe = replaceHash(safe);
  safe = replaceNumberSign(safe);
  return _lodash2.default.truncate(safe, { length: 500 }) || '';
};

var getHandle = function getHandle(post) {
  if (post.type === 'stories') {
    return post.attributes.username;
  }
  switch (post.trackedAsset.platform) {
    case 'YOUTUBE':
      return post.channelTitle;
    case 'TWITTER':
      return post.twitterHandle;
    case 'FACEBOOK':
      return post.facebookHandle || post.influencerName;
    case 'INSTAGRAM':
      return post.instagramHandle || post.influencerName;
    default:
      return null;
  }
};

var getCsvData = function getCsvData(posts) {
  var csvOutput = _lodash2.default.map(posts, function (p) {
    //
    if (_lodash2.default.get(p, 'platform') === 'VK' || _lodash2.default.get(p, 'platform') === 'BLOG' || _lodash2.default.get(p, 'platform') === 'SNAPCHAT') {
      return {
        channel: _lodash2.default.get(p, 'platform'),
        influencer: _lodash2.default.get(p, 'discussionName'),
        date: _lodash2.default.get(p, 'createdDate'),
        post_type: _lodash2.default.get(p, 'assetType'),
        asset_link: _lodash2.default.get(p, 'assetURL'),
        views: (0, _assets.getSupportingDataField)(_lodash2.default.get(p, 'supportingData', []), 'views'),
        likes: (0, _assets.getSupportingDataField)(_lodash2.default.get(p, 'supportingData', []), 'likes'),
        clicks: (0, _assets.getSupportingDataField)(_lodash2.default.get(p, 'supportingData', []), 'clicks'),
        comments: (0, _assets.getSupportingDataField)(_lodash2.default.get(p, 'supportingData', []), 'comments'),
        shares: (0, _assets.getSupportingDataField)(_lodash2.default.get(p, 'supportingData', []), 'shares'),
        caption: safeDescription(_lodash2.default.get(p, 'extraData.text')),
        impressions: '',
        reach: '',
        username: _lodash2.default.get(p, 'discussionName'),
        followerCount: _lodash2.default.get(p, 'followerCount')
      };
    }
    //
    if (p && p.platform && p.platform === 'TIKTOK') {
      var initialData = p.initialData,
          tiktokData = p.tiktokData;

      var latestTiktokData = _lodash2.default.last(_lodash2.default.sortBy(tiktokData, 'createdDate')) || initialData;
      return {
        channel: 'TIKTOK',
        influencer: _lodash2.default.get(p, 'discussionName'),
        influencer_link: "https://www.tiktok.com/@" + _lodash2.default.get(p, 'discussionName'),
        date: _lodash2.default.get(p, 'createdDate'),
        post_type: _lodash2.default.get(p, 'assetType'),
        asset_link: _lodash2.default.get(p, 'assetURL'),
        caption: safeDescription(_lodash2.default.get(p, 'initialData.text')),
        views: _lodash2.default.get(latestTiktokData, 'playCount', ''),
        likes: _lodash2.default.get(latestTiktokData, 'diggCount', ''),
        comments: _lodash2.default.get(latestTiktokData, 'commentCount', ''),
        shares: _lodash2.default.get(latestTiktokData, 'shareCount', ''),
        impressions: '',
        reach: '',
        username: _lodash2.default.get(p, 'discussionName'),
        followerCount: _lodash2.default.get(p, 'initialData.authorMeta.fans')
      };
    }

    if (p.type === 'stories') {
      var _p$attributes = p.attributes,
          storyData = _p$attributes.storyData,
          assetType = _p$attributes.assetType;

      var latestData = _lodash2.default.last(storyData);
      var _supportingData = _lodash2.default.get(p, 'relationships.supportingData.data');

      var _latestSupportingData = void 0;

      if (_supportingData && _supportingData.length) {
        var filtered = _lodash2.default.filter(_supportingData, 'attributes.createdDate'); // remove the GraphQL null at [0]
        var ordered = _lodash2.default.reverse(_lodash2.default.sortBy(filtered, function (o) {
          return _lodash2.default.get(o, 'attributes.createdDate');
        }));
        _latestSupportingData = ordered[0];
      }

      var _data = {
        channel: 'INSTAGRAM',
        influencer: p.attributes.username,
        influencer_link: "https://www.instagram.com/" + p.attributes.username,
        date: latestData.createdDate,
        post_type: 'STORY',
        asset_link: p.attributes.assetURL,
        caption: safeDescription(p.attributes.caption),
        followerCount: _lodash2.default.get(p, 'followerCount'),
        mentions: p.attributes.mentions,
        hashtags: safeDescription(p.attributes.hashtags)
      };

      _lodash2.default.assign(_data, {
        impressions: _lodash2.default.get(_latestSupportingData, 'attributes.impressions', latestData.impressions),
        views: assetType === 'VIDEO' ? _lodash2.default.get(_latestSupportingData, 'attributes.views', latestData.impressions) : '',
        reach: _lodash2.default.get(_latestSupportingData, 'attributes.reach', latestData.reach)
      });

      return _data;
    }

    var stats = p.latestStatistic;
    var insights = _lodash2.default.get(stats, 'insights');
    var supportingData = _lodash2.default.get(p, 'trackedAsset.supportingData');

    var latestSupportingData = void 0;

    if (supportingData && supportingData.length) {
      var _filtered = _lodash2.default.filter(supportingData, 'createdDate'); // remove the GraphQL null at [0]
      var _ordered = _lodash2.default.reverse(_lodash2.default.sortBy(_filtered, function (o) {
        return o.createdDate;
      }));
      latestSupportingData = _ordered[0];
    }

    var postType = p.isVideo ? 'VIDEO' : 'IMAGE';

    if (_lodash2.default.get(p, 'trackedAsset.assetType') === 'STORY') {
      postType = 'STORY';
    }

    var data = {
      channel: p.trackedAsset.platform,
      influencer: safeDescription(getHandle(p)),
      influencer_link: "https://www.instagram.com/" + safeDescription(getHandle(p)),
      followerCount: _lodash2.default.get(p, 'followerCount'),
      date: p.publishedDate || _lodash2.default.get(p, 'trackedAsset.publishedDate', ''),
      post_type: postType,
      asset_link: p.trackedAsset.assetURL,
      caption: safeDescription(p.text),
      isReel: p.isReel || '',
      isIGTV: p.isIGTV || ''
    };

    if (_lodash2.default.get(p, 'trackedAsset.createdSource', '') === 'CAMPAIGN') {
      _lodash2.default.set(data, 'caption', safeDescription(p.text));
    }

    if (stats) {
      _lodash2.default.assign(data, {
        views: stats.playCount || stats.viewCount || stats.openCount || '',
        likes: stats.likeCount || '',
        comments: stats.commentCount || '',
        reactions: stats.reactionCount || '',
        engagements: safeSum(stats, ['viewCount', 'likeCount', 'commentCount', 'reactionCount'])
      });
    }

    if (insights) {
      _lodash2.default.assign(data, {
        impressions: insights.totalVideoImpressions || insights.impressions || '',
        reach: insights.totalVideoImpressionsUnique || insights.reach || '',
        saved: insights.saved || ''
      });
    }

    if (latestSupportingData) {
      _lodash2.default.assign(data, {
        impressions: latestSupportingData.impressions || '',
        reach: latestSupportingData.reach || '',
        saved: latestSupportingData.saves || '',
        engagements: latestSupportingData.engagements || '',
        shares: latestSupportingData.shares || '',
        stickerTaps: latestSupportingData.stickerTaps || ''
      });
    }
    return data;
  });

  return csvOutput;
};

module.exports = {
  getCsvData: getCsvData
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/reports/basic-report/csv-generator.js
 ** module id = 2583
 ** module chunks = 0
 **/